<template>
    <div class="default-banner private-genre-banner">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="gallery-card">
                        <div class="gallery-card__img-wrap">
                            <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-genre-img.png" class="grey-ef"/>
                        </div>
                        <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                            <div class="mb-10">
                                <h4 class="tit tit--xs">근현대미술</h4>
                            </div>
                        </div>
                        <v-divider class="primary"></v-divider>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="gallery-card">
                        <div class="gallery-card__img-wrap">
                            <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-genre-img2.png" class="grey-ef"/>
                        </div>
                        <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                            <div class="mb-10">
                                <h4 class="tit tit--xs">Emerging Artist</h4>
                            </div>
                        </div>
                        <v-divider class="primary"></v-divider>
                    </div>
                </div>
            </div>
            <div class="swiper-control">
                <div class="swiper-prev"><i class="icon icon-arrow-left mr-6"></i><span>PREV</span></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-next"><span>NEXT</span><i class="icon icon-arrow-right ml-6"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper/bundle";
export default {
    props: {
    },
    data(){
        return{
            swiper: undefined,
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            this.$nextTick(() => {
                this.swiper = new Swiper ('.private-genre-banner .swiper-container', {
                    allowTouchMove: false,
                    centeredSlides: true,
                    spaceBetween : 20,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: false,
                    pagination: {
                        el: '.private-genre-banner .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        prevEl: '.private-genre-banner .swiper-prev',
                        nextEl: '.private-genre-banner .swiper-next'
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            centeredSlides: false,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween : 28,
                            centeredSlides: false,
                        },
                        1200: {
                            slidesPerView: 2,
                            centeredSlides: false,
                            freeMode: true,
                        },
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>